import { environment } from "src/environments/environment";

export class FiltroAsignaciones {
    NPerPage: number = 15;
    pageNumber: any = 1;
    pageTotal: any = 10;
    totalItems: any = 0;
    state: string[];
    username: string;
    startDate: string;
    endDate: string;
    description: string;
    assignedTo: string;
    ot: string;
    frencuency: string;
    codigoEstacion: string;
    nombre: string;
    sections: string[];
    sectionsCods: string[];
    orderBy: any = {
        cant:0,
        fecha: { label: "When", value: '-1', apply: true ,order:0},
        codigo: { label: "Status.CodigoEstacion.Observed", apply: false,order:0 },
        seccion: { label: "Status.Seccion.Observed", value: null, apply: false ,order:0},
        ot: { label: "Status.OT.Observed", value: null, apply: false,order:0 },
        asignado: { label: "Who.0.username", value: null, apply: false ,order:0},
        frecuencia: { label: "Status.Frecuencia.Observed", value: null, apply: false ,order:0},
        nombre: { label: "Status.DescriEstacion.Observed", value: null, apply: false ,order:0},
    }

}